export default __webpack_public_path__ + "static/media/player-football.42241270.png";